import React, { useEffect, useState } from 'react';

import { useMutation } from '@apollo/client';
import { faArrowRightFromBracket } from '@fortawesome/pro-light-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, MenuList, MenuItem, ListItemIcon, ListItemText, styled } from '@mui/material';

import QueryWrapper from '../../../../components/QueryWrapper/QueryWrapper';
import auth from '../../../../services/Auth';
import candidateSchema from '../../../../services/candidate/gqlSchema';
import documentSchema from '../../../../services/documents/gqlSchema';
import CandidateService from '../CandidateService';
import { TAB_IDS } from '../data/tabs';

const CustomMenuItem = styled(MenuItem)({
  borderRadius: '0.25rem',
  '&.active': {
    backgroundColor: '#303d4a',
    color: '#fff',
    '& .MuiListItemIcon-root': {
      color: '#fff',
    },
  },
});

const CandidateNav = ({ onChangeTab, tabs, signatures, contact, defaultActive }) => {
  const logout = () => {
    auth.logout({
      redirectToLogin: false,
    });
    auth.forceReload();
  };

  const [activeLink, setActiveLink] = useState(defaultActive);
  const [updateSignature] = useMutation(candidateSchema.Mutation.updateSignature);

  const contactInfoId = contact && contact.contactsInfos[0].id;

  useEffect(() => {
    setActiveLink(defaultActive);
  }, [defaultActive]);

  const changePage = newPage => {
    setActiveLink(newPage);
    onChangeTab(newPage);
  };

  const isSigned = signature => {
    if (signature?.signDate) {
      return (
        <Box sx={{ marginLeft: '10px', display: 'inline-block' }}>
          <FontAwesomeIcon icon={faCircleCheck} />
        </Box>
      );
    } else if (signature?.signUuid) {
      return (
        <QueryWrapper query={candidateSchema.Query.transactionInfo} variables={{ signUuid: signature.signUuid }}>
          {({ data }) => {
            const dataTransactionInfo = data.transactionInfo;
            if (dataTransactionInfo.signerInfos[0].status === 'signed') {
              signature.signDate = dataTransactionInfo.signerInfos[0].actionDate;
              updateSignature({
                variables: {
                  signatureId: signature.id,
                  params: { signDate: dataTransactionInfo.signerInfos[0].actionDate },
                },
              });

              return (
                <Box sx={{ marginLeft: '10px', display: 'inline-block' }}>
                  <FontAwesomeIcon icon={faCircleCheck} />
                </Box>
              );
            } else {
              return '';
            }
          }}
        </QueryWrapper>
      );
    } else {
      return null;
    }
  };

  const displayChecked = tabId => {
    let signature;
    switch (tabId) {
      default:
      case TAB_IDS.CONTRACT:
        signature = CandidateService.getContractSignature(signatures);

        return isSigned(signature);
      case TAB_IDS.DOCUMENTS:
        return (
          <QueryWrapper
            query={documentSchema.Query.contactInfosCandidateDocuments}
            variables={{ contactInfoId: contactInfoId }}
          >
            {({ data }) => {
              if (data.contactInfosCandidateDocuments.length === 3)
                return (
                  <Box sx={{ marginLeft: '10px', display: 'inline-block' }}>
                    <FontAwesomeIcon icon={faCircleCheck} />
                  </Box>
                );

              return '';
            }}
          </QueryWrapper>
        );
      case TAB_IDS.BANK:
        signature = CandidateService.getSepaSignature(signatures);

        return isSigned(signature);
    }
  };

  return (
    <Box id='candidate-nav'>
      <MenuList>
        {tabs.map(tabInfo => (
          <CustomMenuItem
            key={tabInfo.id}
            className={activeLink === tabInfo.id ? 'active' : ''}
            onClick={() => changePage(tabInfo.id)}
          >
            <ListItemIcon>
              <FontAwesomeIcon icon={tabInfo.icon} />
            </ListItemIcon>
            <ListItemText primary={tabInfo.title} secondary={displayChecked(tabInfo.id)} />
          </CustomMenuItem>
        ))}
        <CustomMenuItem onClick={logout}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
          </ListItemIcon>
          <ListItemText>Déconnexion</ListItemText>
        </CustomMenuItem>
      </MenuList>
    </Box>
  );
};

export default CandidateNav;
